import { API_BASE } from "../constants";
import { IVehicleTypeDto } from "../dto/vehicleType";
import { getCompanyId } from "../helpers";
import { apiFindOne } from "./generic-api";

export class VehicleTypeApi {
  static async getOne(id: number): Promise<IVehicleTypeDto | undefined> {
    const requestUrl = `${API_BASE}/c/${getCompanyId()}/vehicleTypes/${id}`;
    const response = await apiFindOne<IVehicleTypeDto>(requestUrl);

    return response;
  }
}
